import layout from 'layouts/default'
import pagination from 'components/pagination'
import { confirm } from 'components/modals'
import toastr from 'toastr'

export default {
  name: 'all-integration-systems',
  components: {
    layout,
    pagination,
    confirm
  },
  data () {
    return {
      loading: true,
      searchKey: null,
      typeFilter: '',
      removing: {}
    }
  },
  computed: {
    integrationSystems () {
      const all = this.$store.state.integrationSystems.all
      return Array.isArray(all) ? {data: all} : Object.assign({data: []}, all)
    }
  },
  watch: {
    typeFilter () {
      this.loadPage(1)
    }
  },
  methods: {
    loadPage (page) {
      this.loading = true
      return this.$store.dispatch('integrationSystems.getAll', {
        page,
        per_page: 5,
        name: this.searchKey || null,
        type: this.typeFilter || null
      }).then(() => {
        this.loading = false
        const error = this.$store.state.integrationSystems.errors
        if (error) toastr.error(error.message)
      })
    },

    search (searchKey) {
      this.searchKey = searchKey
      this.loadPage(1)
    },

    typeLabel (type) {
      return type === 'room' ? 'Room' : 'Parking'
    },

    attributeLabels (attributes) {
      return (attributes || []).map(attribute => attribute.label || attribute.key).join(', ')
    },

    remove (item) {
      this.$refs.deleteConfirm.confirm('Are you sure you want to delete '+item.name+' integration system?', () => {
        this.$set(this.removing, item.id, true)
        this.$store.dispatch('integrationSystems.remove', item.id).then(() => {
          this.$set(this.removing, item.id, false)
          const error = this.$store.state.integrationSystems.errors
          if (error) toastr.error(error.message)
        })
      })
    }
  },
  mounted () {
    this.loadPage(this.$route.query.page || 1)
  }
}
